import { createAction } from '@reduxjs/toolkit'

export const getAutoInviteRule = createAction('autoInvite/getAutoInviteRule')

export const saveAutoInviteRule = createAction('autoInvite/saveAutoInviteRule')
